<template>
  <b-container>
    <b-col lg="8" offset-lg="2" mx="auto">
      <div class="resources">
        <ResourcePreview
          v-for="(resource, index) in resources"
          :key="index"
          :resource="resource"
          :ranking="index"
          :source="pageName"
        />
      </div>
      <nav class="load-more text-center" v-if="hasMoreToShow">
        <b-button v-on:click="loadMoreResources" variant="outline-dark">Load more</b-button>
      </nav>
    </b-col>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ResourcePreview from './ResourcePreview'
import { FETCH_RESOURCES } from '@/store/utils/actions'
import { trackLoadMore } from '@/utils/analytics/main'

export default {
  name: 'ResourcesList',
  components: {
    ResourcePreview
  },
  data () {
    return {
      currentPage: 1,
      noMoreResources: false
    }
  },
  props: {
    itemsPerPage: {
      type: Number,
      default: 10
    },
    topic: {
      type: String
    },
    keywords: {
      type: String
    }
  },
  computed: {
    hasMoreToShow () {
      const resourcesLeft = Math.max(0, this.resourcesTotalCount - (this.currentPage * this.itemsPerPage))
      return Boolean(resourcesLeft)
    },
    pageName () {
      return this.$route.name
    },
    query () {
      const pagination = {
        from: (this.currentPage - 1) * this.itemsPerPage,
        size: this.itemsPerPage
      }
      const filters = {}
      if (this.topic) {
        filters.query = {
          match: {
            tags: this.topic
          }
        }
      }
      if (this.keywords) {
        filters.query = {
          bool: {
            should: [
              { match: { url: this.keywords } },
              { match: { name: this.keywords } },
              { match: { description: this.keywords } }
            ]
          }
        }
      }
      return { ...filters, ...pagination }
    },
    ...mapGetters(['resources', 'resourcesTotalCount', 'isLoading'])
  },
  mounted () {
    this.fethResources()
  },
  methods: {
    fethResources () {
      this.$store.dispatch(FETCH_RESOURCES, { query: this.query, more: false })
    },
    loadMoreResources () {
      const extraParams = {
        source: this.pageName,
        trigger: 'click',
        current_page: this.currentPage
      }
      trackLoadMore(extraParams)
      this.currentPage += 1
      this.$store.dispatch(FETCH_RESOURCES, { query: this.query, more: true })
    }
  },
  watch: {
    '$route' () {
    // Force the store to update with the new route params
    // FIXEME: This implementation is broken, we should call the ``fetchResources`` method but it does not work
      this.$store.dispatch(FETCH_RESOURCES, { query: this.query, more: false })
    }
  }
}
</script>
